import React from 'react';
import { ProductGalleryProps } from './types';
import LazyImage from '../LazyImage';

const ProductGallery: React.FC<ProductGalleryProps> = ({ productData, currentProduct }) => {
  if (!productData || !currentProduct) {
    return null;
  }

  // Collect all unique images from both media and variants
  const allImages: Array<{ url: string; altText: string; id: string }> = [];

  // Add variant images (avoiding duplicates)
  if (currentProduct.variants && currentProduct.variants.edges.length > 0) {
    currentProduct.variants.edges.forEach((variantEdge) => {
      const variant = variantEdge.node;
      if (variant.image?.url) {
        // Check if this image URL is already in our collection
        const isDuplicate = allImages.some((img) => img.url === variant.image!.url);
        if (!isDuplicate) {
          allImages.push({
            url: variant.image.url,
            altText: variant.image.altText || `${productData.title} - ${variant.title}`,
            id: `variant-${variant.id}`,
          });
        }
      }
    });
  }

  // Add general product media images
  if (currentProduct.media && currentProduct.media.edges.length > 0) {
    currentProduct.media.edges
      .filter((mediaEdge) => mediaEdge?.node?.image?.url)
      .forEach((mediaEdge) => {
        allImages.push({
          url: mediaEdge.node.image.url,
          altText: `${productData.title} - View ${allImages.length + 1}`,
          id: mediaEdge.node.id,
        });
      });
  }

  // Don't render if no images found
  if (allImages.length === 0) {
    return null;
  }

  return (
    <div className="product-gallery">
      <div className="gallery-grid">
        {allImages.map((image, index) => (
          <div key={image.id} className="gallery-item">
            <LazyImage src={image.url} alt={image.altText} className="gallery-image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductGallery;
